import React from 'react';
import { Checkbox, FormControlLabel } from '@mui/material';

interface BakeasyCheckboxProps {
  label: string;
  disabled?: boolean;
  fullWidth?: boolean;
  variant?: any;
  style?: React.CSSProperties;
  value: boolean;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

function BakeasyCheckbox(props: BakeasyCheckboxProps) {
  return (
    <FormControlLabel
      sx={{ margin: 0, padding: 0, marginY: -0.5 }}
      control={
        <Checkbox
          onClick={props?.onClick}
          checked={props?.value}
          onChange={props?.onChange}
          size="small"
        />
      }
      label={props?.label}
      disableTypography={true}
    />
  );
}

export default BakeasyCheckbox;
